import { jsx as _jsx } from "react/jsx-runtime";
import { Box, EmptyState } from '@dixa/lib-shared-habla';
/** Represents an empty item. */
export const EmptyItem = ({ searchTerm }) => {
    return (_jsx(Box, Object.assign({ as: "li", padding: "200 300" }, { children: _jsx(EmptyState, { title: searchTerm.length === 0
                ? 'No tags available'
                : 'No tags match the criteria', description: searchTerm.length === 0
                ? 'Try typing a tag name to quick add or go to tag settings'
                : 'Try changing your search criteria or create a new one' }) })));
};
